import { EBuildingHeatingType } from '../../../../json_query';
import { IBuildingHeatingTypesTag } from '../../../state/tags/definitions/building_heating';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const buildingHeatingMap = {
  [EBuildingHeatingType.Autonomous]: 'Автономное отопление',
  [EBuildingHeatingType.Central]: 'Центральное отопление',
  [EBuildingHeatingType.Without]: 'Без отопления',
};

export const BuildingHeatingTypesTagItem = getMultiSelectionParamTagItem<
  EBuildingHeatingType,
  IBuildingHeatingTypesTag
>(buildingHeatingMap);
